        
import React, { Component } from "react";
import UserIcon from "../../assets/icons8-user-activity-50.png";
import urls from "../../custom_libraries/urls";
import {get, getFreshToken} from "../../custom_libraries/serverRequests";
import { Button, Box, Paper} from '@mui/material';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2b313e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------


function initials(name) {
  return name.split(" ").map((w) => w[0]).join("").toUpperCase();
}

function getMaxCount(logs) {
  let max = 0;
  Object.values(logs).forEach((users) =>
    Object.values(users).forEach((c) => { if (c > max) max = c; })
  );
  return max;
}

class UserActivityInSystem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      user: "",
      loading: true,
      error: "",
      next: null, // URL for the next page
      previous: null, // URL for the previous page
      filteredLogs: [],
      fromDate: '',
      toDate:'',
      selectedModel:'',
      filterType : '24h',
      activeUser: "all",

      // selectedChangeType
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    this.fetchActivityLogs();
  }

  validateSignedIn = async () => {
      try {
        let is_fresh_token = await getFreshToken();
        console.log("Fresh Token:", is_fresh_token);
    
        if (!is_fresh_token) {
          console.log("Navigating to login...");
          this.props.navigate("/");
          return;
        }
      } catch (error) {
        console.error("Error in validateSignedIn:", error);
      }
    }

  fetchActivityLogs = async () => {
    try {
      const { filterType } = this.state;

      
      // Construct the URL with query parameters
    const url = urls.GET_ALERT_RESOLVED_ACTIVITY_COUNT(filterType);

    console.log("----URL to fetch activity log----", url);

    let response = await get(url);
    console.log("------Activity Logs Response--------", response);


      this.setState({
        // user: response.data.user,
        logs: response,
        loading: false,
        
      });
    } catch (err) {
      this.setState({
        error: "Failed to fetch activity logs. Please try again.",
        loading: false,
      });
    }
  };


handleFilterChange = (event) => {
  this.setState({ filterType: event.target.value }, () => {
    this.fetchActivityLogs();
  });
};

// handleApplyFilter = () => {
//   const { filterType, logs, fromDate, toDate, selectedModel } = this.state;
//   let filtered = logs;

//   if (filterType === "date") {
//     filtered = logs.filter(log => {
//       const logDate = new Date(log.timestamp);
//       return logDate >= new Date(fromDate) && logDate <= new Date(toDate);
//     });
//   } else if (filterType === "model") {
//     filtered = logs.filter(log => log.model === selectedModel);
//   } 
//   // else if (filterType === "change_type") {
//   //   filtered = logs.filter(log => log.change_type === selectedChangeType);
//   // }

//   this.setState({ filteredLogs: filtered });
// };

ClearFilter = () => {
  this.setState(
    { filterType: "", fromDate: "", toDate: "", selectedModel: "" },
    () => {
      this.fetchActivityLogs(); // Ensure this runs after state update
    }
  );
}

// Helper to update state
  setActiveUser = (user) => {
    this.setState({ activeUser: user });
  };

  getDynamicColors = (name) => {
  // Simple hash function to turn a string into a number
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use the hash to get a Hue (0-360)
  const h = Math.abs(hash) % 360;

  return {
    // Light background (95% lightness)
    bg: `hsl(${h}, 70%, 95%)`,
    // Dark text (20% lightness)
    text: `hsl(${h}, 80%, 20%)`,
    // Vibrant bar (50% lightness)
    bar: `hsl(${h}, 60%, 50%)`
  };
};

  render() {
    // const { logs, user, loading, error, previous, next } = this.state;

    const { filteredLogs, user, loading, error, previous, next, filterType, fromDate, toDate, selectedModel, selectedChangeType, logs, activeUser } = this.state;

    // const uniqueChangeTypes = [...new Set(logs.map(log => log.change_type))];

    if (loading) return <p style={{marginLeft:'1cm', color:'#cbcbcb'}}>Loading...</p>;

    if (!logs) {
      return <p style={{ marginLeft:'1cm', color: "#ffb968" }}>No logs</p>;
    }

    // Normalize: support both array and object formats
    const normalizedLogs = Array.isArray(logs)
      ? { "": Object.fromEntries(logs.map((l) => [l.updated_by, l.alerts_cleared])) }
      : logs;

    const allUsers = [...new Set(Object.values(normalizedLogs).flatMap((u) => Object.keys(u)))];
    const max = getMaxCount(normalizedLogs);

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
          <Box component={Paper} 
            sx={{height: "78vh", margin:'1.2% 1% 1% 1%', padding:'15px', overflow: 'auto', 
                "&::-webkit-scrollbar": { width: "8px" },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#052f81",
                  borderRadius: "10px",
                },
                '@media (max-width: 768px)': {
                  marginLeft: "50px"
                }
            }}>
            <div>
              {/* <h4> ACTIVITY </h4> */}
              {error && <p style={{ color: "red" }}>{error}</p>}
              
              {/* Filter Selection */}
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <p className="activityDealer"> {filterType === "7d" ? "7 Days" : filterType === "24h" ? "24 hrs" : "" } Activity Logs </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <label style={{fontSize:'14px', whiteSpace: 'nowrap', color: '#d4e4f9'}}><b> Filter by: </b></label>
                  <select value={filterType} onChange={this.handleFilterChange}>
                    <option value="">Select Filter</option>
                    <option value="7d">7 Days</option>
                    <option value="24h">24 Hours</option>
                  </select>
                </div>
              </div>
            <div style={{ marginBottom: "15px", display: 'flex', alignItems: 'center', gap: '15px' }}>
              
            </div>

              {/* <div className="logs-list">
                {logs ? (
                    Array.isArray(logs) ? (
                    logs.map((log, index) => (
                        <div key={index} className="activitySubDesc">
                        <img src={UserIcon} alt="user-icon" width="23px" /> {log.updated_by} : {log.alerts_cleared}
                        </div>
                    ))
                    ) : (
                    Object.entries(logs).map(([date, users], index) => (
                        <div key={index}>
                        <p className="activityTime">{date}</p>

                        {Object.entries(users).map(([user, count], i) => (
                            <div key={i}>
                            <img src={UserIcon} alt="user-icon" width="23px" /><span className="activityDescription">{user} :</span> <span className="activitySubDesc">{count}</span>
                            </div>
                        ))}
                        </div>
                    ))
                    )
                ) : (
                    <p>No logs</p>
                )}
                </div> */}

                <div style={{ padding: "0" }}>
        
                {/* User filter pills */}
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 16 }}>
                  {["all", ...allUsers].map((user) => (
                    <button
                      key={user}
                      onClick={() => this.setActiveUser(user)}
                      style={{
                        padding: "4px 12px",
                        borderRadius: 100,
                        fontSize: 14,
                        cursor: "pointer",
                        border: "0.5px solid",
                        borderColor: activeUser === user ? "#3266ad" : "var(--color-border-secondary)",
                        background: activeUser === user ? "#3266ad" : "transparent",
                        color: activeUser === user ? "#fff" : "var(--color-text-secondary)",
                        transition: "all 0.15s",
                      }}
                    >
                      {user === "all" ? "All users" : user}
                    </button>
                  ))}
                </div>

                {/* Day blocks */}
                <div style={{ display: "flex", flexDirection: "column", gap: 0, height: "70vh", overflowY: "auto" }}>
                  {Object.entries(normalizedLogs).map(([date, users]) => {
                    const filtered =
                      activeUser === "all"
                        ? users
                        : Object.fromEntries(
                            Object.entries(users).filter(
                              ([u]) => u.toLowerCase() === activeUser.toLowerCase()
                            )
                          );

                    if (!Object.keys(filtered).length) return null;

                    // const total = Object.values(filtered).reduce((a, b) => a + b, 0);
                    // Calculate the total for THIS specific day (e.g., 11 + 5 = 16)
                    const dailyTotal = Object.values(filtered).reduce((a, b) => a + b, 0) || 1;

                    return (
                      <Box component={Paper} key={date} style={{ marginBottom: 16, backgroundColor: "#2c3547" }}>
                        {/* Day header */}
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                          <span style={{ fontSize: 14, fontWeight: 600, color: "#a0bbeb", textTransform: "uppercase", letterSpacing: "0.06em", whiteSpace: "nowrap" }}>
                            {date}
                          </span>
                          <div style={{ flex: 1, height: "0.5px", background: "var(--color-border-tertiary)" }} />
                          <span style={{ fontSize: 14.5, whiteSpace: "nowrap" }}>
                            <span style={{color: "#a8a8a8",}}> Total alerts resolved on this day: </span><b>{dailyTotal}</b>
                          </span>
                        </div>

                        {/* Log rows */}
                        {Object.entries(filtered).map(([user, count]) => {
                          const c = this.getDynamicColors(user);
                          const pct = Math.round((count / dailyTotal) * 100);

                          return (
                            <div
                              key={user}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                padding: "7px 10px",
                                borderRadius: "var(--border-radius-md)",
                                // border: "0.5px solid #fff",
                                background: "var(--color-background-primary)",
                                marginBottom: 6,
                              }}
                            >
                              {/* Avatar */}
                              <div style={{
                                width: 32, height: 32, borderRadius: "50%",
                                background: c.bg, color: c.text,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 14, fontWeight: "650", flexShrink: 0,
                                textShadow: `0.5px 0 ${c.text}, -0.5px 0 ${c.text}, 0 0.5px ${c.text}, 0 -0.5px ${c.text}`
                              }}>
                                {initials(user)}
                              </div>

                              {/* Username */}
                              <span style={{ fontSize: 14, fontWeight: 500, color: "var(--color-text-primary)", flex: "0 0 80px" }}>
                                {user}
                              </span>

                              {/* Progress bar */}
                              <div style={{ flex: 1, height: 4, background: "var(--color-border-tertiary)", borderRadius: 4, overflow: "hidden" }}>
                                <div style={{ width: `${pct}%`, height: "100%", background: c.bar, borderRadius: 4, transition: "width 0.3s ease" }} />
                              </div>

                              <span style={{ fontSize: 14, fontWeight: 500, color: "#a8a8a8", flex: "0 0 20px" }}>
                                Resolved
                              </span>
                               
                              {/* Count badge */}
                              <span style={{
                                display: "inline-flex", alignItems: "center", justifyContent: "center",
                                minWidth: 28, padding: "2px 4px", borderRadius: 100,
                                fontSize: 14, fontWeight: 600,
                                background: c.bg, color: c.text,
                                textShadow: `0.3px 0 ${c.text}, -0.3px 0 ${c.text}, 0 0.3px ${c.text}, 0 -0.3px ${c.text}`
                              }}>
                                {count}
                              </span>
                            </div>
                          );
                        })}
                      </Box>
                    );
                  })}
                </div>
              </div>
    

            </div>
            
          </Box>
      </ThemeProvider>
    );
  }
}

export default UserActivityInSystem;
